// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Responsive adjustments for MobileCoreMenu
   Uses a --mc-scale variable to shrink fonts, gaps and paddings across breakpoints.
   Many inline styles exist in the component; we use !important to make the adjustments
   take effect even when inline styles are present. Keep rules targeted to avoid
   unintended global overrides. */

.mobile-menu-root {
  --mc-scale: 1;
  /* base font for rem fallback */
  font-size: calc(14px * var(--mc-scale)) !important;
}

/* General scaling for common elements */
.mobile-menu-root, .mobile-menu-root * {
  --mc-scale: inherit;
}

.mobile-menu-root .mobile-menu-btn,
.mobile-menu-root .horizontal-tab,
.mobile-menu-root .wallet-connector,
.mobile-menu-root .wallet-modal,
.mobile-menu-root .connect-popup,
.mobile-menu-root .mobile-menu-fallback-admin,
.mobile-menu-root .mobile-menu-fallback-button,
.mobile-menu-root .horizontal-menu-container,
.mobile-menu-root .horizontal-menu-header {
  font-size: calc(13px * var(--mc-scale)) !important;
}

.mobile-menu-root .mobile-menu-label,
.mobile-menu-root .mobile-menu-title,
.mobile-menu-root .horizontal-tab .tab-label,
.mobile-menu-root .wallet-text,
.mobile-menu-root .wallet-status,
.mobile-menu-root .stat-value {
  font-size: calc(13px * var(--mc-scale)) !important;
}

.mobile-menu-root .mobile-menu-icon,
.mobile-menu-root .tab-icon,
.mobile-menu-root .wallet-emoji {
  font-size: calc(18px * var(--mc-scale)) !important;
}

.mobile-menu-root .mobile-menu-list button.mobile-menu-btn,
.mobile-menu-root .horizontal-tab-menu .horizontal-tab {
  padding: calc(8px * var(--mc-scale)) !important;
  gap: calc(8px * var(--mc-scale)) !important;
}

.mobile-menu-root .wallet-connector {
  padding: calc(8px * var(--mc-scale)) !important;
  border-radius: calc(10px * var(--mc-scale)) !important;
}

.mobile-menu-root .horizontal-data-summary .stat-item {
  padding: calc(6px * var(--mc-scale)) !important;
}

.mobile-menu-root .mobile-menu-fallback-admin {
  width: calc(300px * var(--mc-scale)) !important;
  padding: calc(10px * var(--mc-scale)) !important;
}

.mobile-menu-root .mobile-menu-fallback-button,
.mobile-menu-root .mobile-menu-fallback-minimized {
  right: calc(12px * var(--mc-scale)) !important;
  bottom: calc(80px * var(--mc-scale)) !important;
  padding: calc(8px * var(--mc-scale)) calc(12px * var(--mc-scale)) !important;
}

.mobile-menu-root .wallet-modal {
  width: calc(320px * var(--mc-scale)) !important;
  max-width: 96% !important;
  padding: calc(12px * var(--mc-scale)) !important;
}

.mobile-menu-root .connect-popup .connect-popup-content {
  padding: calc(12px * var(--mc-scale)) !important;
}

.mobile-menu-root .notification-container .notification {
  padding: calc(8px * var(--mc-scale)) !important;
  font-size: calc(12px * var(--mc-scale)) !important;
}

/* Breakpoints adjust the scale variable */
@media (max-width: 1200px) {
  .mobile-menu-root { --mc-scale: 0.95; }
}
@media (max-width: 1000px) {
  .mobile-menu-root { --mc-scale: 0.9; }
}
@media (max-width: 820px) {
  .mobile-menu-root { --mc-scale: 0.85; }
}
@media (max-width: 600px) {
  .mobile-menu-root { --mc-scale: 0.78; }
}
@media (max-width: 420px) {
  .mobile-menu-root { --mc-scale: 0.72; }
}

/* When horizontal menu is open on mobile, keep compact layout */
.mobile-menu-root .horizontal-menu-container { gap: calc(8px * var(--mc-scale)) !important; }

/* ensure orb scales visually too */
.mobile-menu-root .mobile-menu-orb { transform-origin: center center; transform: scale(var(--mc-scale)) !important; }

/* subtle override to ensure clickable areas remain large enough */
.mobile-menu-root .mobile-menu-btn, .mobile-menu-root .wallet-connector { min-height: calc(40px * var(--mc-scale)) !important; }

/* End of MobileCoreMenu responsive CSS */
/* Mobile Core Menu - Enhanced Glassmorphic Design with Neon Green Accents */
.mobile-menu-root {
  --solana-gradient: linear-gradient(135deg, #9945ff 0%, #14f195 50%, #4e44ce 100%);
  --neon-green: #14f195;
  --neon-green-glow: rgba(20, 241, 149, 0.6);
  --glass-bg: rgba(255, 255, 255, 0.08);
  --glass-border: rgba(20, 241, 149, 0.2);
  --glass-shadow: rgba(0, 0, 0, 0.25);
  --purple-glow: #9945ff;
  --admin-gold: #ffd700;
}

.mobile-menu-root {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background: 
    radial-gradient(circle at 20% 80%, rgba(20, 241, 149, 0.12) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(153, 69, 255, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 40% 40%, rgba(78, 68, 206, 0.08) 0%, transparent 50%),
    linear-gradient(135deg, #0a0b1e 0%, #1a1b2e 50%, #16213e 100%);
  color: #fff;
  overflow: hidden;
  pointer-events: none;
  transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.mobile-menu-root.menu-open {
  background: 
    radial-gradient(circle at 20% 80%, rgba(20, 241, 149, 0.18) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(153, 69, 255, 0.15) 0%, transparent 50%),
    radial-gradient(circle at 40% 40%, rgba(78, 68, 206, 0.12) 0%, transparent 50%),
    linear-gradient(135deg, #0a0b1e 0%, #1a1b2e 50%, #16213e 100%);
  backdrop-filter: blur(5px);
  pointer-events: auto;
}

.mobile-menu-root > * {
  pointer-events: auto;
}

.mobile-menu-root::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 50% 50%, transparent 0%, rgba(10, 11, 30, 0.4) 100%);
  pointer-events: none;
}

/* Enhanced Glassmorphic Orb with Neon Effects */
/* Enhanced Glassmorphic Orb - Centered and Responsive */
/* Core Orb - compact for mobile and desktop with optional animated core behavior */
.mobile-menu-orb {
  position: fixed;
  /* moved to a mobile-friendly bottom-right location by default */
  right: 18px;
  bottom: 18px;
  transform: none;
  width: 84px;
  height: 84px;
  background: rgba(255, 255, 255, 0.04);
  backdrop-filter: blur(25px);
  border: 4px solid var(--neon-green);
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
  box-shadow:
    0 20px 50px rgba(0, 0, 0, 0.3),
    0 0 30px var(--neon-green-glow),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
  z-index: 1000;
  overflow: visible;
  animation: diskFloat 6s ease-in-out infinite;
} 
.mobile-menu-orb.menu-open {
  animation: diskPulse 2s ease-in-out infinite;
  transform: scale(1.06);
  right: 18px;
  bottom: 18px;
  transition: all 0.36s cubic-bezier(0.34, 1.56, 0.64, 1);
}

/* optional small inner rotation to give the orb a 'core' animation */
.mobile-menu-orb::after {
  content: '';
  position: absolute;
  inset: 6px;
  border-radius: 50%;
  background: radial-gradient(circle at 30% 30%, rgba(255,255,255,0.02), transparent 36%);
  pointer-events: none;
  z-index: 1;
  transition: transform 0.6s ease;
}
.mobile-menu-orb.menu-open::after { transform: rotate(24deg); }

.orb-glow-ring {
  position: absolute;
  top: -10px;
  left: -10px;
  right: -10px;
  bottom: -10px;
  border-radius: 50%;
  background: conic-gradient(from 0deg, var(--neon-green), transparent, var(--purple-glow), transparent, var(--neon-green));
  opacity: 0.3;
  animation: rotateGlow 4s linear infinite;
  z-index: -1;
}

.mobile-menu-orb::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(
    45deg,
    transparent 30%,
    rgba(20, 241, 149, 0.15) 50%,
    transparent 70%
  );
  animation: orbShimmer 3s ease-in-out infinite;
}

/* Santa hat removed */

/* Subtle snow background: light, slow falling layers using radial-gradients. Low opacity for readability */
.mobile-menu-root::after {
  content: '';
  position: absolute;
  inset: 0;
  z-index: 100; /* behind orb (orb has 1000+) */
  pointer-events: none;
  opacity: 0.08;
  background-image:
    radial-gradient(circle at 10% 0%, rgba(255,255,255,0.95) 0.8px, transparent 1.8px),
    radial-gradient(circle at 30% -20%, rgba(255,255,255,0.95) 0.9px, transparent 2px),
    radial-gradient(circle at 60% -10%, rgba(255,255,255,0.95) 0.7px, transparent 1.6px),
    radial-gradient(circle at 80% -30%, rgba(255,255,255,0.95) 1px, transparent 2.2px);
  background-repeat: repeat;
  background-size: 60px 140px, 80px 200px, 40px 110px, 100px 240px;
  background-position: 0 -40px, 20px -80px, 40px -20px, 10px -120px;
  animation: snowFall 18s linear infinite;
}

@keyframes snowFall {
  0% {
    background-position: 0 -40px, 20px -80px, 40px -20px, 10px -120px;
  }
  100% {
    background-position: 0 100vh, 20px 120vh, 40px 80vh, 10px 160vh;
  }
}

.mobile-menu-orb:hover {
  transform: translate(-50%, 50%) scale(1.08);
  background: rgba(20, 241, 149, 0.08);
  border-color: var(--neon-green);
  box-shadow: 
    0 25px 60px rgba(0, 0, 0, 0.4),
    0 0 40px var(--neon-green-glow),
    0 0 120px 30px var(--neon-green-glow),
    0 0 200px 40px rgba(20, 241, 149, 0.3),
    inset 0 2px 0 rgba(255, 255, 255, 0.4),
    inset 0 -2px 0 rgba(20, 241, 149, 0.4);
}

.mobile-menu-orb:active {
  transform: translate(-50%, 50%) scale(1.02);
}

/* Admin Orb Enhancement */
.mobile-menu-orb.admin-orb {
  /* Admin orb: use same base/inner color as regular users (neon-green)
     but render a golden outer glow ring and keep the crown element visible. */
  /* keep the main orb visuals consistent with regular users */
  border-color: var(--neon-green);
  box-shadow: 
    0 20px 50px rgba(0, 0, 0, 0.3),
    0 0 30px var(--neon-green-glow),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
}

/* On hover keep base neon behavior but emphasize the outer golden glow via the orb-glow-ring override */
.mobile-menu-orb.admin-orb:hover {
  border-color: var(--neon-green);
  transform: translate(-50%, 50%) scale(1.08);
  background: rgba(20, 241, 149, 0.08);
  box-shadow: 
    0 25px 60px rgba(0, 0, 0, 0.4),
    0 0 40px var(--neon-green-glow),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
}

/* The outer glow ring for admin orb should be golden while leaving inner gradients intact */
.mobile-menu-orb.admin-orb .orb-glow-ring {
  background: conic-gradient(from 0deg, var(--admin-gold), transparent, var(--purple-glow), transparent, var(--admin-gold));
  opacity: 0.5;
  filter: blur(6px);
}

.admin-crown {
  position: absolute;
  top: -5px;
  right: 10px;
  font-size: 24px;
  animation: crownFloat 2s ease-in-out infinite;
  filter: drop-shadow(0 0 10px rgba(255, 215, 0, 0.8));
}

.mobile-menu-logo {
  font-size: 42px;
  font-weight: 900;
  background: linear-gradient(135deg, #ffffff 0%, var(--neon-green) 50%, #9945ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 0 40px var(--neon-green-glow);
  z-index: 2;
  position: relative;
  margin-top: -8px;
  line-height: 1;
}

.mobile-menu-orb {
  position: fixed;
  text-shadow: 0 0 15px var(--neon-green-glow);
  text-align: center;
  line-height: 1;
}

.mobile-menu-list {
  /* Bottom-anchored panel so options are reachable on mobile
     Be scrollable when too tall to fit the viewport */
  position: fixed;
  right: 12px;
  bottom: 110px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: calc(100% - 48px);
  max-width: 420px;
  align-items: stretch;
  z-index: 9999;
  margin: 0;
  max-height: calc(100vh - 160px);
  overflow-y: auto;
  padding: 10px;
  box-sizing: border-box;
}

.mobile-menu-btn {
  background: var(--glass-bg);
  backdrop-filter: blur(18px);
  border: 1.2px solid var(--glass-border);
  color: #fff;
  font-weight: 700;
  border-radius: 14px;
  padding: 14px 18px;
  font-size: 15px;
  margin-bottom: 10px;
  width: 100%;
  box-shadow: 
    0 8px 30px var(--glass-shadow),
    0 0 16px rgba(20, 241, 149, 0.08),
    inset 0 1px 0 rgba(255, 255, 255, 0.08);
  cursor: pointer;
  transition: all 0.22s cubic-bezier(0.34, 1.56, 0.64, 1);
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;
  overflow: hidden;
  opacity: 1;
  transform: translateY(0) scale(1);
}

.mobile-menu-btn:nth-child(1) { animation-delay: 0.1s; }
.mobile-menu-btn:nth-child(2) { animation-delay: 0.2s; }
.mobile-menu-btn:nth-child(3) { animation-delay: 0.3s; }
.mobile-menu-btn:nth-child(4) { animation-delay: 0.4s; }

.mobile-menu-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(20, 241, 149, 0.15),
    transparent
  );
  transition: left 0.5s ease;
}

.mobile-menu-btn:hover::before {
  left: 100%;
}

.mobile-menu-btn:hover {
  transform: translateY(-3px) scale(1.03);
  background: rgba(20, 241, 149, 0.08);
  border-color: var(--neon-green);
  box-shadow: 
    0 15px 50px var(--glass-shadow),
    0 0 30px var(--neon-green-glow),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

.mobile-menu-btn:active {
  transform: translateY(0) scale(0.98);
}

.mobile-menu-btn.admin-highlighted {
  border-color: var(--admin-gold);
  box-shadow: 
    0 10px 40px var(--glass-shadow),
    0 0 25px rgba(255, 215, 0, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.15);
}

/* Mode-specific styling with enhanced neon effects */
.mobile-menu-btn.kiosk-mode {
  border-left: 4px solid var(--neon-green);
}

.mobile-menu-btn.kiosk-mode:hover {
  box-shadow: 
    0 15px 50px var(--glass-shadow),
    0 0 35px var(--neon-green-glow),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

.mobile-menu-btn.admin-mode {
  border-left: 4px solid #9945ff;
}

.mobile-menu-btn.admin-mode:hover {
  box-shadow: 
    0 15px 50px var(--glass-shadow),
    0 0 35px rgba(153, 69, 255, 0.5),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

.mobile-menu-btn.student-mode {
  border-left: 4px solid #4e44ce;
}

.mobile-menu-btn.student-mode:hover {
  box-shadow: 
    0 15px 50px var(--glass-shadow),
    0 0 35px rgba(78, 68, 206, 0.5),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

.mobile-menu-icon {
  font-size: 26px;
  min-width: 26px;
  background: var(--solana-gradient);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  filter: drop-shadow(0 0 10px var(--neon-green-glow));
}

.mobile-menu-label {
  font-size: 17px;
  font-weight: 600;
  flex: 1 1;
  text-align: left;
  background: linear-gradient(135deg, #ffffff 0%, rgba(255, 255, 255, 0.85) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Animations */
@keyframes orbShimmer {
  0%, 100% { transform: translateX(-100%) translateY(-100%) rotate(0deg); }
  50% { transform: translateX(100%) translateY(100%) rotate(180deg); }
}

@keyframes menuItemSlideIn {
  0% {
    opacity: 0;
    transform: translateY(30px) scale(0.8);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes radialOpen {
  0% {
    opacity: 0;
    transform: scale(0) rotate(-180deg);
    filter: blur(10px);
  }
  50% {
    opacity: 0.7;
    filter: blur(2px);
  }
  100% {
    opacity: 1;
    transform: scale(1) rotate(0deg);
    filter: blur(0);
  }
}

/* Radial opening animation for menu items */
.mobile-menu-list.opening .mobile-menu-btn {
  animation: radialOpen 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}

.mobile-menu-list.opening .mobile-menu-btn:nth-child(1) { animation-delay: 0.1s; }
.mobile-menu-list.opening .mobile-menu-btn:nth-child(2) { animation-delay: 0.2s; }
.mobile-menu-list.opening .mobile-menu-btn:nth-child(3) { animation-delay: 0.3s; }
.mobile-menu-list.opening .mobile-menu-btn:nth-child(4) { animation-delay: 0.4s; }

/* Responsive adjustments */
@media (max-width: 600px) {
  .mobile-menu-orb {
    width: 72px;
    height: 72px;
    right: 12px;
    bottom: 12px;
  }

  .mobile-menu-list {
    right: 8px;
    bottom: 96px;
    width: calc(100% - 24px);
    max-width: 360px;
    padding: 8px;
    gap: 8px;
  }

  .mobile-menu-btn {
    padding: 12px 14px;
    font-size: 14px;
  }

  .mobile-menu-logo { font-size: 34px; }
}

/* Ensure menu buttons are reachable when many items exist: compact grid for very narrow screens */
@media (max-width: 360px) {
  .mobile-menu-list {
    display: grid;
    grid-template-columns: 1fr;
    gap: 8px;
    max-height: calc(100vh - 140px);
  }
  .mobile-menu-btn { padding: 10px 12px; font-size: 13px; }
}

/* ======================== WALLET STATUS ICON ======================== */

.wallet-status-icon {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: var(--glass-bg);
  backdrop-filter: blur(20px);
  border: 2px solid var(--glass-border);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  z-index: 1000;
  position: relative;
  overflow: hidden;
}

.wallet-status-icon::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 50%;
  background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.1), transparent);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.wallet-status-icon:hover::before {
  opacity: 1;
}

.wallet-status-icon:hover {
  transform: scale(1.1);
  box-shadow: 
    0 8px 32px rgba(0, 0, 0, 0.3),
    0 0 20px rgba(255, 255, 255, 0.1);
}

.wallet-icon-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  z-index: 2;
}

.wallet-emoji {
  filter: drop-shadow(0 0 8px rgba(255, 255, 255, 0.3));
}

.wallet-spinner {
  animation: spin 1s linear infinite;
  font-size: 20px;
  color: var(--neon-glow);
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.wallet-status-dot {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
}

.wallet-status-icon.connected .wallet-status-dot {
  background: #14f195;
  box-shadow: 
    0 0 10px #14f195,
    inset 0 0 5px rgba(255, 255, 255, 0.3);
  animation: pulse-green 2s ease-in-out infinite;
}

.wallet-status-icon.disconnected .wallet-status-dot {
  background: #ff9500;
  box-shadow: 
    0 0 10px #ff9500,
    inset 0 0 5px rgba(255, 255, 255, 0.3);
  animation: pulse-orange 2s ease-in-out infinite;
}

.wallet-status-icon.connecting .wallet-status-dot {
  background: #9945ff;
  box-shadow: 
    0 0 10px #9945ff,
    inset 0 0 5px rgba(255, 255, 255, 0.3);
  animation: pulse-purple 1s ease-in-out infinite;
}

@keyframes pulse-green {
  0%, 100% { 
    box-shadow: 
      0 0 10px #14f195,
      inset 0 0 5px rgba(255, 255, 255, 0.3);
  }
  50% { 
    box-shadow: 
      0 0 20px #14f195,
      0 0 30px rgba(20, 241, 149, 0.3),
      inset 0 0 8px rgba(255, 255, 255, 0.5);
  }
}

@keyframes pulse-orange {
  0%, 100% { 
    box-shadow: 
      0 0 10px #ff9500,
      inset 0 0 5px rgba(255, 255, 255, 0.3);
  }
  50% { 
    box-shadow: 
      0 0 20px #ff9500,
      0 0 30px rgba(255, 149, 0, 0.3),
      inset 0 0 8px rgba(255, 255, 255, 0.5);
  }
}

@keyframes pulse-purple {
  0%, 100% { 
    box-shadow: 
      0 0 10px #9945ff,
      inset 0 0 5px rgba(255, 255, 255, 0.3);
  }
  50% { 
    box-shadow: 
      0 0 20px #9945ff,
      0 0 30px rgba(153, 69, 255, 0.3),
      inset 0 0 8px rgba(255, 255, 255, 0.5);
  }
}

/* ======================== WALLET MODAL ======================== */

.wallet-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  animation: fadeIn 0.3s ease-out;
}

.wallet-modal {
  background: var(--glass-bg);
  backdrop-filter: blur(30px);
  border: 1px solid var(--glass-border);
  border-radius: 20px;
  width: 90%;
  max-width: 400px;
  box-shadow: 
    0 20px 60px rgba(0, 0, 0, 0.4),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
  animation: slideInUp 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  overflow: hidden;
}

.wallet-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 28px 16px 28px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.wallet-modal-header h3 {
  margin: 0;
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  background: var(--solana-gradient);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.wallet-modal-close {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.6);
  font-size: 24px;
  cursor: pointer;
  padding: 4px;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.wallet-modal-close:hover {
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.9);
  transform: scale(1.1);
}

.wallet-modal-content {
  padding: 24px 28px 28px 28px;
}

.wallet-info {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  font-size: 18px;
  font-weight: 600;
  color: #fff;
}

.wallet-status-indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  animation: pulse 2s ease-in-out infinite;
}

.wallet-status-indicator.connected {
  background: #14f195;
  box-shadow: 0 0 10px #14f195;
}

.wallet-status-indicator.disconnected {
  background: #ff9500;
  box-shadow: 0 0 10px #ff9500;
}

.wallet-address {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 24px;
  font-family: 'Monaco', 'Menlo', monospace;
  font-size: 16px;
  color: var(--neon-glow);
  text-align: center;
  word-break: break-all;
}

.wallet-actions {
  display: flex;
  gap: 12px;
  flex-direction: column;
}

.wallet-btn {
  padding: 14px 24px;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  position: relative;
  overflow: hidden;
}

.wallet-btn.primary {
  background: var(--solana-gradient);
  color: #fff;
  box-shadow: 0 4px 20px rgba(153, 69, 255, 0.3);
}

.wallet-btn.primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(153, 69, 255, 0.4);
}

.wallet-btn.secondary {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.wallet-btn.secondary:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: translateY(-2px);
}

.wallet-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.wallet-btn:active {
  transform: scale(0.98);
}

.wallet-modal p {
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.5;
  margin-bottom: 24px;
  text-align: center;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(50px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* ======================== HORIZONTAL MENU FOR MOBILE ADMIN ======================== */

.horizontal-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(10px);
  z-index: 2000;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 0;
  animation: fadeIn 0.3s ease-out;
}

.horizontal-menu-container {
  background: var(--glass-bg);
  backdrop-filter: blur(30px);
  border: 1px solid var(--glass-border);
  border-radius: 0 0 25px 25px;
  width: 100%;
  max-width: 100vw;
  box-shadow: 
    0 20px 60px rgba(0, 0, 0, 0.4),
    0 0 40px var(--neon-green-glow),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
  animation: slideDownIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  overflow: hidden;
}

.horizontal-menu-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 25px 15px 25px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background: linear-gradient(135deg, 
    rgba(20, 241, 149, 0.1) 0%, 
    rgba(153, 69, 255, 0.05) 50%,
    rgba(255, 215, 0, 0.1) 100%);
}

.logo-section {
  display: flex;
  align-items: center;
  gap: 15px;
}

.logo-icon {
  font-size: 32px;
  background: var(--solana-gradient);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  filter: drop-shadow(0 0 15px var(--neon-green-glow));
}

.logo-text h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 900;
  background: linear-gradient(135deg, #ffffff 0%, var(--neon-green) 50%, var(--admin-gold) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 0 20px var(--neon-green-glow);
  line-height: 1;
}

.logo-text span {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-top: 2px;
  display: block;
}

.close-horizontal-menu {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: rgba(255, 255, 255, 0.8);
  font-size: 20px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.close-horizontal-menu:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: var(--neon-green);
  color: var(--neon-green);
  transform: scale(1.1);
}

.horizontal-tab-menu {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1px;
  background: rgba(255, 255, 255, 0.05);
  margin: 0;
}

.horizontal-tab {
  background: var(--glass-bg);
  backdrop-filter: blur(25px);
  border: none;
  color: #fff;
  padding: 20px 15px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;
  overflow: hidden;
  border-bottom: 2px solid transparent;
}

.horizontal-tab::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(20, 241, 149, 0.1), transparent);
  transition: left 0.5s ease;
}

.horizontal-tab:hover::before {
  left: 100%;
}

.horizontal-tab:hover {
  background: rgba(20, 241, 149, 0.08);
  border-bottom-color: var(--neon-green);
  transform: translateY(-2px);
}

.horizontal-tab.active {
  background: rgba(20, 241, 149, 0.15);
  border-bottom-color: var(--neon-green);
  box-shadow: 
    0 0 20px rgba(20, 241, 149, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

.horizontal-tab.admin-mode.active {
  border-bottom-color: var(--admin-gold);
  background: rgba(255, 215, 0, 0.15);
  box-shadow: 
    0 0 20px rgba(255, 215, 0, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

.tab-icon {
  font-size: 24px;
  min-width: 24px;
  background: var(--solana-gradient);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  filter: drop-shadow(0 0 10px var(--neon-green-glow));
}

.tab-content {
  flex: 1 1;
  text-align: left;
}

.tab-label {
  font-size: 16px;
  font-weight: 600;
  display: block;
  margin-bottom: 4px;
  background: linear-gradient(135deg, #ffffff 0%, rgba(255, 255, 255, 0.9) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.tab-description {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 400;
}

.admin-crown-tab {
  font-size: 18px;
  animation: crownFloat 2s ease-in-out infinite;
  filter: drop-shadow(0 0 8px rgba(255, 215, 0, 0.8));
}

.horizontal-wallet-status {
  padding: 20px 25px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background: linear-gradient(135deg, 
    rgba(20, 241, 149, 0.05) 0%, 
    transparent 50%,
    rgba(255, 215, 0, 0.05) 100%);
}

.wallet-info-horizontal {
  display: flex;
  align-items: center;
  gap: 15px;
}

.wallet-details {
  display: flex;
  flex-direction: column;
  flex: 1 1;
}

.wallet-details .wallet-status {
  font-size: 14px;
  font-weight: 600;
  color: var(--neon-green);
  margin-bottom: 2px;
}

.wallet-address-horizontal {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  font-family: 'Monaco', 'Menlo', monospace;
}

.admin-badge-horizontal {
  font-size: 10px;
  background: var(--admin-gold);
  color: #000;
  padding: 4px 8px;
  border-radius: 10px;
  font-weight: 700;
}

/* Hide orb when horizontal menu is shown */
.mobile-menu-orb.menu-hidden {
  opacity: 0;
  pointer-events: none;
  transform: translate(-50%, 50%) scale(0.8);
}

/* Animations for horizontal menu */
@keyframes slideDownIn {
  0% {
    opacity: 0;
    transform: translateY(-100%);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Mobile wallet adjustments */
@media (max-width: 480px) {
  .wallet-status-icon {
    width: 50px;
    height: 50px;
    bottom: 20px;
    right: 20px;
  }
  
  .wallet-icon-inner {
    font-size: 20px;
  }
  
  .wallet-status-dot {
    width: 10px;
    height: 10px;
    top: 6px;
    right: 6px;
  }
  
  .wallet-modal {
    margin: 20px;
    width: calc(100% - 40px);
  }
  
  .wallet-modal-header {
    padding: 20px 24px 12px 24px;
  }
  
  .wallet-modal-content {
    padding: 20px 24px 24px 24px;
  }

  .wallet-connector-container {
    bottom: 40px;
  }

  .wallet-connector {
    min-width: 180px;
    padding: 14px 20px;
  }

  .admin-welcome .welcome-content {
    padding: 25px 35px;
    margin: 0 20px;
  }

  /* Mobile horizontal menu adjustments */
  .horizontal-menu-header {
    padding: 15px 20px 12px 20px;
  }

  .logo-text h1 {
    font-size: 20px;
  }

  .horizontal-tab {
    padding: 18px 12px;
    gap: 10px;
  }

  .tab-icon {
    font-size: 20px;
  }

  .tab-label {
    font-size: 14px;
  }

  .tab-description {
    font-size: 11px;
  }

  .horizontal-wallet-status {
    padding: 15px 20px;
  }
}

/* Admin Welcome Message */
.admin-welcome {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 3000;
  animation: welcomeSlideIn 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.welcome-content {
  background: var(--glass-bg);
  backdrop-filter: blur(30px);
  border: 2px solid var(--admin-gold);
  border-radius: 20px;
  padding: 30px 40px;
  text-align: center;
  box-shadow: 
    0 20px 60px rgba(0, 0, 0, 0.4),
    0 0 40px rgba(255, 215, 0, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  gap: 20px;
}

.welcome-icon {
  font-size: 40px;
  animation: crownFloat 2s ease-in-out infinite;
  filter: drop-shadow(0 0 15px rgba(255, 215, 0, 0.8));
}

.welcome-text h3 {
  margin: 0 0 8px 0;
  font-size: 24px;
  font-weight: 700;
  background: linear-gradient(135deg, var(--admin-gold) 0%, #fff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.welcome-text p {
  margin: 0;
  color: rgba(255, 255, 255, 0.8);
  font-size: 16px;
}

/* Wallet Connector - Lower Middle Section */
.wallet-connector-container {
  position: fixed;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
}

.wallet-connector {
  background: var(--glass-bg);
  backdrop-filter: blur(25px);
  border: 2px solid var(--glass-border);
  border-radius: 25px;
  padding: 16px 24px;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  position: relative;
  overflow: hidden;
  min-width: 200px;
  box-shadow: 
    0 10px 40px rgba(0, 0, 0, 0.3),
    0 0 20px rgba(20, 241, 149, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
}

.wallet-connector-glow {
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  border-radius: 25px;
  background: conic-gradient(from 0deg, var(--neon-green), transparent, var(--purple-glow), transparent, var(--neon-green));
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: -1;
}

.wallet-connector:hover .wallet-connector-glow {
  opacity: 0.3;
  animation: rotateGlow 2s linear infinite;
}

.wallet-connector:hover {
  transform: translateY(-3px) scale(1.02);
  border-color: var(--neon-green);
  box-shadow: 
    0 15px 50px rgba(0, 0, 0, 0.4),
    0 0 30px var(--neon-green-glow),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

.wallet-connector.admin-wallet {
  border-color: var(--admin-gold);
}

.wallet-connector.admin-wallet:hover {
  border-color: var(--admin-gold);
  box-shadow: 
    0 15px 50px rgba(0, 0, 0, 0.4),
    0 0 30px rgba(255, 215, 0, 0.4),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

.wallet-connector-content {
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;
  z-index: 2;
}

.wallet-info-compact {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}

.wallet-status {
  font-size: 14px;
  font-weight: 600;
  color: var(--neon-green);
}

.wallet-address-short {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  font-family: 'Monaco', 'Menlo', monospace;
}

.admin-badge {
  font-size: 10px;
  background: var(--admin-gold);
  color: #000;
  padding: 2px 6px;
  border-radius: 8px;
  font-weight: 700;
  margin-top: 2px;
}

.wallet-text {
  font-size: 14px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
}

.wallet-emoji {
  font-size: 20px;
  filter: drop-shadow(0 0 8px rgba(255, 255, 255, 0.3));
}

.wallet-status-dot {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
}

.wallet-status-dot.connected {
  background: var(--neon-green);
  box-shadow: 0 0 10px var(--neon-green);
  animation: pulse-green 2s ease-in-out infinite;
}

.wallet-status-dot.disconnected {
  background: #ff9500;
  box-shadow: 0 0 10px #ff9500;
  animation: pulse-orange 2s ease-in-out infinite;
}

.wallet-status-dot.admin {
  background: var(--admin-gold);
  box-shadow: 0 0 10px var(--admin-gold);
  animation: pulse-gold 2s ease-in-out infinite;
}

/* Enhanced Animations */
@keyframes welcomeSlideIn {
  0% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.7) rotate(-10deg);
  }
  100% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1) rotate(0deg);
  }
}

@keyframes crownFloat {
  0%, 100% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-8px) rotate(5deg);
  }
}

@keyframes rotateGlow {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes diskFloat {
  0%, 100% {
    transform: translate(-50%, 50%) translateY(0px) rotate(0deg);
  }
  33% {
    transform: translate(-50%, 50%) translateY(-5px) rotate(1deg);
  }
  66% {
    transform: translate(-50%, 50%) translateY(3px) rotate(-1deg);
  }
}

@keyframes diskPulse {
  0%, 100% {
    box-shadow: 
      0 20px 50px rgba(0, 0, 0, 0.3),
      0 0 30px var(--neon-green-glow),
      inset 0 1px 0 rgba(255, 255, 255, 0.1);
  }
  50% {
    box-shadow: 
      0 25px 60px rgba(0, 0, 0, 0.4),
      0 0 50px var(--neon-green-glow),
      0 0 80px rgba(20, 241, 149, 0.4),
      inset 0 1px 0 rgba(255, 255, 255, 0.15);
  }
}

@keyframes pulse-green {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.7;
    transform: scale(1.1);
  }
}

@keyframes pulse-orange {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.7;
    transform: scale(1.1);
  }
}

@keyframes pulse-gold {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.7;
    transform: scale(1.1);
  }
}

/* Connect Popup */
.connect-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 3000;
  animation: welcomeSlideIn 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.connect-popup-content {
  background: var(--glass-bg);
  backdrop-filter: blur(30px);
  border: 2px solid var(--neon-green);
  border-radius: 20px;
  padding: 30px 35px;
  text-align: center;
  box-shadow: 
    0 20px 60px rgba(0, 0, 0, 0.4),
    0 0 40px var(--neon-green-glow),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
  max-width: 320px;
  margin: 0 20px;
}

.connect-popup-content h4 {
  margin: 0 0 12px 0;
  font-size: 22px;
  font-weight: 700;
  background: linear-gradient(135deg, var(--neon-green) 0%, #fff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.connect-popup-content p {
  margin: 0 0 16px 0;
  color: rgba(255, 255, 255, 0.8);
  font-size: 15px;
  line-height: 1.4;
}

/* Small shimmer skeleton for StatsGrid initial load */
.stat-shimmer {
  height: 44px;
  border-radius: 8px;
  background: linear-gradient(90deg, rgba(255,255,255,0.03) 25%, rgba(255,255,255,0.06) 50%, rgba(255,255,255,0.03) 75%);
  background-size: 200% 100%;
  animation: shimmer 1.2s linear infinite;
}

@keyframes shimmer {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}
`, "",{"version":3,"sources":["webpack://./src/components/MobileCoreMenu.css"],"names":[],"mappings":"AAAA;;;;iCAIiC;;AAEjC;EACE,aAAa;EACb,+BAA+B;EAC/B,kDAAkD;AACpD;;AAEA,wCAAwC;AACxC;EACE,mBAAmB;AACrB;;AAEA;;;;;;;;;EASE,kDAAkD;AACpD;;AAEA;;;;;;EAME,kDAAkD;AACpD;;AAEA;;;EAGE,kDAAkD;AACpD;;AAEA;;EAEE,+CAA+C;EAC/C,2CAA2C;AAC7C;;AAEA;EACE,+CAA+C;EAC/C,sDAAsD;AACxD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;EAC/C,gDAAgD;AAClD;;AAEA;;EAEE,8CAA8C;EAC9C,+CAA+C;EAC/C,4EAA4E;AAC9E;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,+CAA+C;EAC/C,kDAAkD;AACpD;;AAEA,0CAA0C;AAC1C;EACE,oBAAoB,gBAAgB,EAAE;AACxC;AACA;EACE,oBAAoB,eAAe,EAAE;AACvC;AACA;EACE,oBAAoB,gBAAgB,EAAE;AACxC;AACA;EACE,oBAAoB,gBAAgB,EAAE;AACxC;AACA;EACE,oBAAoB,gBAAgB,EAAE;AACxC;;AAEA,gEAAgE;AAChE,+CAA+C,2CAA2C,EAAE;;AAE5F,mCAAmC;AACnC,qCAAqC,+BAA+B,EAAE,4CAA4C,EAAE;;AAEpH,kEAAkE;AAClE,0EAA0E,mDAAmD,EAAE;;AAE/H,yCAAyC;AACzC,4EAA4E;AAC5E;EACE,iFAAiF;EACjF,qBAAqB;EACrB,0CAA0C;EAC1C,qCAAqC;EACrC,uCAAuC;EACvC,mCAAmC;EACnC,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ;;;;kEAIgE;EAChE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,sDAAsD;AACxD;;AAEA;EACE;;;;kEAIgE;EAChE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,0FAA0F;EAC1F,oBAAoB;AACtB;;AAEA,gDAAgD;AAChD,wDAAwD;AACxD,mFAAmF;AACnF;EACE,eAAe;EACf,gEAAgE;EAChE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sDAAsD;EACtD;;;0CAGwC;EACxC,aAAa;EACb,iBAAiB;EACjB,4CAA4C;AAC9C;AACA;EACE,4CAA4C;EAC5C,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,uDAAuD;AACzD;;AAEA,qEAAqE;AACrE;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,uFAAuF;EACvF,oBAAoB;EACpB,UAAU;EACV,+BAA+B;AACjC;AACA,oCAAoC,wBAAwB,EAAE;;AAE9D;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yHAAyH;EACzH,YAAY;EACZ,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,6CAA6C;AAC/C;;AAEA,sBAAsB;;AAEtB,2GAA2G;AAC3G;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,YAAY,EAAE,+BAA+B;EAC7C,oBAAoB;EACpB,aAAa;EACb;;;;sFAIoF;EACpF,yBAAyB;EACzB,gEAAgE;EAChE,iEAAiE;EACjE,uCAAuC;AACzC;;AAEA;EACE;IACE,iEAAiE;EACnE;EACA;IACE,+DAA+D;EACjE;AACF;;AAEA;EACE,2CAA2C;EAC3C,oCAAoC;EACpC,+BAA+B;EAC/B;;;;;;0CAMwC;AAC1C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,0BAA0B;AAC1B;EACE;8EAC4E;EAC5E,4DAA4D;EAC5D,+BAA+B;EAC/B;;;0CAGwC;AAC1C;;AAEA,wGAAwG;AACxG;EACE,+BAA+B;EAC/B,2CAA2C;EAC3C,oCAAoC;EACpC;;;0CAGwC;AAC1C;;AAEA,4FAA4F;AAC5F;EACE,yHAAyH;EACzH,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,6CAA6C;EAC7C,oDAAoD;AACtD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oFAAoF;EACpF,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,4CAA4C;EAC5C,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,4CAA4C;EAC5C,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE;sDACoD;EACpD,eAAe;EACf,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,wBAAwB;EACxB,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,uCAAuC;EACvC,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX;;;2CAGyC;EACzC,eAAe;EACf,uDAAuD;EACvD,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,iCAAiC;AACnC;;AAEA,gCAAgC,qBAAqB,EAAE;AACvD,gCAAgC,qBAAqB,EAAE;AACvD,gCAAgC,qBAAqB,EAAE;AACvD,gCAAgC,qBAAqB,EAAE;;AAEvD;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uCAAuC;EACvC,oCAAoC;EACpC,+BAA+B;EAC/B;;;0CAGwC;AAC1C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;EAC/B;;;2CAGyC;AAC3C;;AAEA,qDAAqD;AACrD;EACE,wCAAwC;AAC1C;;AAEA;EACE;;;0CAGwC;AAC1C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;;;0CAGwC;AAC1C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;;;0CAGwC;AAC1C;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kCAAkC;EAClC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,oDAAoD;AACtD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAO;EACP,gBAAgB;EAChB,+EAA+E;EAC/E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,WAAW,2DAA2D,EAAE;EACxE,MAAM,2DAA2D,EAAE;AACrE;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,UAAU;IACV,mCAAmC;IACnC,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,gCAAgC;IAChC,eAAe;EACjB;AACF;;AAEA,4CAA4C;AAC5C;EACE,qEAAqE;AACvE;;AAEA,0DAA0D,qBAAqB,EAAE;AACjF,0DAA0D,qBAAqB,EAAE;AACjF,0DAA0D,qBAAqB,EAAE;AACjF,0DAA0D,qBAAqB,EAAE;;AAEjF,2BAA2B;AAC3B;EACE;IACE,WAAW;IACX,YAAY;IACZ,WAAW;IACX,YAAY;EACd;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,wBAAwB;IACxB,gBAAgB;IAChB,YAAY;IACZ,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA,oBAAoB,eAAe,EAAE;AACvC;;AAEA,kGAAkG;AAClG;EACE;IACE,aAAa;IACb,0BAA0B;IAC1B,QAAQ;IACR,+BAA+B;EACjC;EACA,mBAAmB,kBAAkB,EAAE,eAAe,EAAE;AAC1D;;AAEA,yEAAyE;;AAEzE;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,2BAA2B;EAC3B,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sDAAsD;EACtD,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,sFAAsF;EACtF,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB;;qCAEmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB;;0CAEwC;EACxC,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB;;0CAEwC;EACxC,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB;;0CAEwC;EACxC,+CAA+C;AACjD;;AAEA;EACE;IACE;;4CAEwC;EAC1C;EACA;IACE;;;4CAGwC;EAC1C;AACF;;AAEA;EACE;IACE;;4CAEwC;EAC1C;EACA;IACE;;;4CAGwC;EAC1C;AACF;;AAEA;EACE;IACE;;4CAEwC;EAC1C;EACA;IACE;;;4CAGwC;EAC1C;AACF;;AAEA,mEAAmE;;AAEnE;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,qCAAqC;EACrC,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB;;0CAEwC;EACxC,2DAA2D;EAC3D,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,iDAAiD;AACnD;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sDAAsD;EACtD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,uFAAuF;;AAEvF;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,qCAAqC;EACrC,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;EAChB;;;0CAGwC;EACxC,6DAA6D;EAC7D,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,iDAAiD;EACjD;;;gCAG8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,oDAAoD;AACtD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,8FAA8F;EAC9F,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,+BAA+B;EAC/B,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,sDAAsD;EACtD,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,qFAAqF;EACrF,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC;;0CAEwC;AAC1C;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;EACnC;;0CAEwC;AAC1C;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kCAAkC;EAClC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,oDAAoD;AACtD;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,8EAA8E;EAC9E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,6CAA6C;EAC7C,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,8CAA8C;EAC9C;;;iCAG+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,UAAU;EACV,oBAAoB;EACpB,0CAA0C;AAC5C;;AAEA,mCAAmC;AACnC;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA,uCAAuC;EACvC;IACE,4BAA4B;EAC9B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,gEAAgE;AAClE;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB;;;0CAGwC;EACxC,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,6CAA6C;EAC7C,oDAAoD;AACtD;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oEAAoE;EACpE,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,eAAe;AACjB;;AAEA,4CAA4C;AAC5C;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,sDAAsD;EACtD,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB;;;0CAGwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yHAAyH;EACzH,UAAU;EACV,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;EACvC,+BAA+B;EAC/B;;;0CAGwC;AAC1C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B;;;0CAGwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,+CAA+C;AACjD;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA,wBAAwB;AACxB;EACE;IACE,UAAU;IACV,0DAA0D;EAC5D;EACA;IACE,UAAU;IACV,sDAAsD;EACxD;AACF;;AAEA;EACE;IACE,uCAAuC;EACzC;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE;IACE,4DAA4D;EAC9D;EACA;IACE,6DAA6D;EAC/D;EACA;IACE,6DAA6D;EAC/D;AACF;;AAEA;EACE;IACE;;;4CAGwC;EAC1C;EACA;IACE;;;;6CAIyC;EAC3C;AACF;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,qBAAqB;EACvB;AACF;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,gEAAgE;AAClE;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB;;;0CAGwC;EACxC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oEAAoE;EACpE,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA,sDAAsD;AACtD;EACE,YAAY;EACZ,kBAAkB;EAClB,sHAAsH;EACtH,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE,KAAK,4BAA4B,EAAE;EACnC,OAAO,2BAA2B,EAAE;AACtC","sourcesContent":["/* Responsive adjustments for MobileCoreMenu\n   Uses a --mc-scale variable to shrink fonts, gaps and paddings across breakpoints.\n   Many inline styles exist in the component; we use !important to make the adjustments\n   take effect even when inline styles are present. Keep rules targeted to avoid\n   unintended global overrides. */\n\n.mobile-menu-root {\n  --mc-scale: 1;\n  /* base font for rem fallback */\n  font-size: calc(14px * var(--mc-scale)) !important;\n}\n\n/* General scaling for common elements */\n.mobile-menu-root, .mobile-menu-root * {\n  --mc-scale: inherit;\n}\n\n.mobile-menu-root .mobile-menu-btn,\n.mobile-menu-root .horizontal-tab,\n.mobile-menu-root .wallet-connector,\n.mobile-menu-root .wallet-modal,\n.mobile-menu-root .connect-popup,\n.mobile-menu-root .mobile-menu-fallback-admin,\n.mobile-menu-root .mobile-menu-fallback-button,\n.mobile-menu-root .horizontal-menu-container,\n.mobile-menu-root .horizontal-menu-header {\n  font-size: calc(13px * var(--mc-scale)) !important;\n}\n\n.mobile-menu-root .mobile-menu-label,\n.mobile-menu-root .mobile-menu-title,\n.mobile-menu-root .horizontal-tab .tab-label,\n.mobile-menu-root .wallet-text,\n.mobile-menu-root .wallet-status,\n.mobile-menu-root .stat-value {\n  font-size: calc(13px * var(--mc-scale)) !important;\n}\n\n.mobile-menu-root .mobile-menu-icon,\n.mobile-menu-root .tab-icon,\n.mobile-menu-root .wallet-emoji {\n  font-size: calc(18px * var(--mc-scale)) !important;\n}\n\n.mobile-menu-root .mobile-menu-list button.mobile-menu-btn,\n.mobile-menu-root .horizontal-tab-menu .horizontal-tab {\n  padding: calc(8px * var(--mc-scale)) !important;\n  gap: calc(8px * var(--mc-scale)) !important;\n}\n\n.mobile-menu-root .wallet-connector {\n  padding: calc(8px * var(--mc-scale)) !important;\n  border-radius: calc(10px * var(--mc-scale)) !important;\n}\n\n.mobile-menu-root .horizontal-data-summary .stat-item {\n  padding: calc(6px * var(--mc-scale)) !important;\n}\n\n.mobile-menu-root .mobile-menu-fallback-admin {\n  width: calc(300px * var(--mc-scale)) !important;\n  padding: calc(10px * var(--mc-scale)) !important;\n}\n\n.mobile-menu-root .mobile-menu-fallback-button,\n.mobile-menu-root .mobile-menu-fallback-minimized {\n  right: calc(12px * var(--mc-scale)) !important;\n  bottom: calc(80px * var(--mc-scale)) !important;\n  padding: calc(8px * var(--mc-scale)) calc(12px * var(--mc-scale)) !important;\n}\n\n.mobile-menu-root .wallet-modal {\n  width: calc(320px * var(--mc-scale)) !important;\n  max-width: 96% !important;\n  padding: calc(12px * var(--mc-scale)) !important;\n}\n\n.mobile-menu-root .connect-popup .connect-popup-content {\n  padding: calc(12px * var(--mc-scale)) !important;\n}\n\n.mobile-menu-root .notification-container .notification {\n  padding: calc(8px * var(--mc-scale)) !important;\n  font-size: calc(12px * var(--mc-scale)) !important;\n}\n\n/* Breakpoints adjust the scale variable */\n@media (max-width: 1200px) {\n  .mobile-menu-root { --mc-scale: 0.95; }\n}\n@media (max-width: 1000px) {\n  .mobile-menu-root { --mc-scale: 0.9; }\n}\n@media (max-width: 820px) {\n  .mobile-menu-root { --mc-scale: 0.85; }\n}\n@media (max-width: 600px) {\n  .mobile-menu-root { --mc-scale: 0.78; }\n}\n@media (max-width: 420px) {\n  .mobile-menu-root { --mc-scale: 0.72; }\n}\n\n/* When horizontal menu is open on mobile, keep compact layout */\n.mobile-menu-root .horizontal-menu-container { gap: calc(8px * var(--mc-scale)) !important; }\n\n/* ensure orb scales visually too */\n.mobile-menu-root .mobile-menu-orb { transform-origin: center center; transform: scale(var(--mc-scale)) !important; }\n\n/* subtle override to ensure clickable areas remain large enough */\n.mobile-menu-root .mobile-menu-btn, .mobile-menu-root .wallet-connector { min-height: calc(40px * var(--mc-scale)) !important; }\n\n/* End of MobileCoreMenu responsive CSS */\n/* Mobile Core Menu - Enhanced Glassmorphic Design with Neon Green Accents */\n.mobile-menu-root {\n  --solana-gradient: linear-gradient(135deg, #9945ff 0%, #14f195 50%, #4e44ce 100%);\n  --neon-green: #14f195;\n  --neon-green-glow: rgba(20, 241, 149, 0.6);\n  --glass-bg: rgba(255, 255, 255, 0.08);\n  --glass-border: rgba(20, 241, 149, 0.2);\n  --glass-shadow: rgba(0, 0, 0, 0.25);\n  --purple-glow: #9945ff;\n  --admin-gold: #ffd700;\n}\n\n.mobile-menu-root {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  min-height: 100vh;\n  width: 100vw;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  background: \n    radial-gradient(circle at 20% 80%, rgba(20, 241, 149, 0.12) 0%, transparent 50%),\n    radial-gradient(circle at 80% 20%, rgba(153, 69, 255, 0.1) 0%, transparent 50%),\n    radial-gradient(circle at 40% 40%, rgba(78, 68, 206, 0.08) 0%, transparent 50%),\n    linear-gradient(135deg, #0a0b1e 0%, #1a1b2e 50%, #16213e 100%);\n  color: #fff;\n  overflow: hidden;\n  pointer-events: none;\n  transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.mobile-menu-root.menu-open {\n  background: \n    radial-gradient(circle at 20% 80%, rgba(20, 241, 149, 0.18) 0%, transparent 50%),\n    radial-gradient(circle at 80% 20%, rgba(153, 69, 255, 0.15) 0%, transparent 50%),\n    radial-gradient(circle at 40% 40%, rgba(78, 68, 206, 0.12) 0%, transparent 50%),\n    linear-gradient(135deg, #0a0b1e 0%, #1a1b2e 50%, #16213e 100%);\n  backdrop-filter: blur(5px);\n  pointer-events: auto;\n}\n\n.mobile-menu-root > * {\n  pointer-events: auto;\n}\n\n.mobile-menu-root::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: radial-gradient(circle at 50% 50%, transparent 0%, rgba(10, 11, 30, 0.4) 100%);\n  pointer-events: none;\n}\n\n/* Enhanced Glassmorphic Orb with Neon Effects */\n/* Enhanced Glassmorphic Orb - Centered and Responsive */\n/* Core Orb - compact for mobile and desktop with optional animated core behavior */\n.mobile-menu-orb {\n  position: fixed;\n  /* moved to a mobile-friendly bottom-right location by default */\n  right: 18px;\n  bottom: 18px;\n  transform: none;\n  width: 84px;\n  height: 84px;\n  background: rgba(255, 255, 255, 0.04);\n  backdrop-filter: blur(25px);\n  border: 4px solid var(--neon-green);\n  border-radius: 50%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);\n  box-shadow:\n    0 20px 50px rgba(0, 0, 0, 0.3),\n    0 0 30px var(--neon-green-glow),\n    inset 0 1px 0 rgba(255, 255, 255, 0.1);\n  z-index: 1000;\n  overflow: visible;\n  animation: diskFloat 6s ease-in-out infinite;\n} \n.mobile-menu-orb.menu-open {\n  animation: diskPulse 2s ease-in-out infinite;\n  transform: scale(1.06);\n  right: 18px;\n  bottom: 18px;\n  transition: all 0.36s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n/* optional small inner rotation to give the orb a 'core' animation */\n.mobile-menu-orb::after {\n  content: '';\n  position: absolute;\n  inset: 6px;\n  border-radius: 50%;\n  background: radial-gradient(circle at 30% 30%, rgba(255,255,255,0.02), transparent 36%);\n  pointer-events: none;\n  z-index: 1;\n  transition: transform 0.6s ease;\n}\n.mobile-menu-orb.menu-open::after { transform: rotate(24deg); }\n\n.orb-glow-ring {\n  position: absolute;\n  top: -10px;\n  left: -10px;\n  right: -10px;\n  bottom: -10px;\n  border-radius: 50%;\n  background: conic-gradient(from 0deg, var(--neon-green), transparent, var(--purple-glow), transparent, var(--neon-green));\n  opacity: 0.3;\n  animation: rotateGlow 4s linear infinite;\n  z-index: -1;\n}\n\n.mobile-menu-orb::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  left: -50%;\n  width: 200%;\n  height: 200%;\n  background: linear-gradient(\n    45deg,\n    transparent 30%,\n    rgba(20, 241, 149, 0.15) 50%,\n    transparent 70%\n  );\n  animation: orbShimmer 3s ease-in-out infinite;\n}\n\n/* Santa hat removed */\n\n/* Subtle snow background: light, slow falling layers using radial-gradients. Low opacity for readability */\n.mobile-menu-root::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  z-index: 100; /* behind orb (orb has 1000+) */\n  pointer-events: none;\n  opacity: 0.08;\n  background-image:\n    radial-gradient(circle at 10% 0%, rgba(255,255,255,0.95) 0.8px, transparent 1.8px),\n    radial-gradient(circle at 30% -20%, rgba(255,255,255,0.95) 0.9px, transparent 2px),\n    radial-gradient(circle at 60% -10%, rgba(255,255,255,0.95) 0.7px, transparent 1.6px),\n    radial-gradient(circle at 80% -30%, rgba(255,255,255,0.95) 1px, transparent 2.2px);\n  background-repeat: repeat;\n  background-size: 60px 140px, 80px 200px, 40px 110px, 100px 240px;\n  background-position: 0 -40px, 20px -80px, 40px -20px, 10px -120px;\n  animation: snowFall 18s linear infinite;\n}\n\n@keyframes snowFall {\n  0% {\n    background-position: 0 -40px, 20px -80px, 40px -20px, 10px -120px;\n  }\n  100% {\n    background-position: 0 100vh, 20px 120vh, 40px 80vh, 10px 160vh;\n  }\n}\n\n.mobile-menu-orb:hover {\n  transform: translate(-50%, 50%) scale(1.08);\n  background: rgba(20, 241, 149, 0.08);\n  border-color: var(--neon-green);\n  box-shadow: \n    0 25px 60px rgba(0, 0, 0, 0.4),\n    0 0 40px var(--neon-green-glow),\n    0 0 120px 30px var(--neon-green-glow),\n    0 0 200px 40px rgba(20, 241, 149, 0.3),\n    inset 0 2px 0 rgba(255, 255, 255, 0.4),\n    inset 0 -2px 0 rgba(20, 241, 149, 0.4);\n}\n\n.mobile-menu-orb:active {\n  transform: translate(-50%, 50%) scale(1.02);\n}\n\n/* Admin Orb Enhancement */\n.mobile-menu-orb.admin-orb {\n  /* Admin orb: use same base/inner color as regular users (neon-green)\n     but render a golden outer glow ring and keep the crown element visible. */\n  /* keep the main orb visuals consistent with regular users */\n  border-color: var(--neon-green);\n  box-shadow: \n    0 20px 50px rgba(0, 0, 0, 0.3),\n    0 0 30px var(--neon-green-glow),\n    inset 0 1px 0 rgba(255, 255, 255, 0.1);\n}\n\n/* On hover keep base neon behavior but emphasize the outer golden glow via the orb-glow-ring override */\n.mobile-menu-orb.admin-orb:hover {\n  border-color: var(--neon-green);\n  transform: translate(-50%, 50%) scale(1.08);\n  background: rgba(20, 241, 149, 0.08);\n  box-shadow: \n    0 25px 60px rgba(0, 0, 0, 0.4),\n    0 0 40px var(--neon-green-glow),\n    inset 0 1px 0 rgba(255, 255, 255, 0.1);\n}\n\n/* The outer glow ring for admin orb should be golden while leaving inner gradients intact */\n.mobile-menu-orb.admin-orb .orb-glow-ring {\n  background: conic-gradient(from 0deg, var(--admin-gold), transparent, var(--purple-glow), transparent, var(--admin-gold));\n  opacity: 0.5;\n  filter: blur(6px);\n}\n\n.admin-crown {\n  position: absolute;\n  top: -5px;\n  right: 10px;\n  font-size: 24px;\n  animation: crownFloat 2s ease-in-out infinite;\n  filter: drop-shadow(0 0 10px rgba(255, 215, 0, 0.8));\n}\n\n.mobile-menu-logo {\n  font-size: 42px;\n  font-weight: 900;\n  background: linear-gradient(135deg, #ffffff 0%, var(--neon-green) 50%, #9945ff 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  text-shadow: 0 0 40px var(--neon-green-glow);\n  z-index: 2;\n  position: relative;\n  margin-top: -8px;\n  line-height: 1;\n}\n\n.mobile-menu-orb {\n  position: fixed;\n  text-shadow: 0 0 15px var(--neon-green-glow);\n  text-align: center;\n  line-height: 1;\n}\n\n.mobile-menu-list {\n  /* Bottom-anchored panel so options are reachable on mobile\n     Be scrollable when too tall to fit the viewport */\n  position: fixed;\n  right: 12px;\n  bottom: 110px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: calc(100% - 48px);\n  max-width: 420px;\n  align-items: stretch;\n  z-index: 9999;\n  margin: 0;\n  max-height: calc(100vh - 160px);\n  overflow-y: auto;\n  padding: 10px;\n  box-sizing: border-box;\n}\n\n.mobile-menu-btn {\n  background: var(--glass-bg);\n  backdrop-filter: blur(18px);\n  border: 1.2px solid var(--glass-border);\n  color: #fff;\n  font-weight: 700;\n  border-radius: 14px;\n  padding: 14px 18px;\n  font-size: 15px;\n  margin-bottom: 10px;\n  width: 100%;\n  box-shadow: \n    0 8px 30px var(--glass-shadow),\n    0 0 16px rgba(20, 241, 149, 0.08),\n    inset 0 1px 0 rgba(255, 255, 255, 0.08);\n  cursor: pointer;\n  transition: all 0.22s cubic-bezier(0.34, 1.56, 0.64, 1);\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  position: relative;\n  overflow: hidden;\n  opacity: 1;\n  transform: translateY(0) scale(1);\n}\n\n.mobile-menu-btn:nth-child(1) { animation-delay: 0.1s; }\n.mobile-menu-btn:nth-child(2) { animation-delay: 0.2s; }\n.mobile-menu-btn:nth-child(3) { animation-delay: 0.3s; }\n.mobile-menu-btn:nth-child(4) { animation-delay: 0.4s; }\n\n.mobile-menu-btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(20, 241, 149, 0.15),\n    transparent\n  );\n  transition: left 0.5s ease;\n}\n\n.mobile-menu-btn:hover::before {\n  left: 100%;\n}\n\n.mobile-menu-btn:hover {\n  transform: translateY(-3px) scale(1.03);\n  background: rgba(20, 241, 149, 0.08);\n  border-color: var(--neon-green);\n  box-shadow: \n    0 15px 50px var(--glass-shadow),\n    0 0 30px var(--neon-green-glow),\n    inset 0 1px 0 rgba(255, 255, 255, 0.2);\n}\n\n.mobile-menu-btn:active {\n  transform: translateY(0) scale(0.98);\n}\n\n.mobile-menu-btn.admin-highlighted {\n  border-color: var(--admin-gold);\n  box-shadow: \n    0 10px 40px var(--glass-shadow),\n    0 0 25px rgba(255, 215, 0, 0.3),\n    inset 0 1px 0 rgba(255, 255, 255, 0.15);\n}\n\n/* Mode-specific styling with enhanced neon effects */\n.mobile-menu-btn.kiosk-mode {\n  border-left: 4px solid var(--neon-green);\n}\n\n.mobile-menu-btn.kiosk-mode:hover {\n  box-shadow: \n    0 15px 50px var(--glass-shadow),\n    0 0 35px var(--neon-green-glow),\n    inset 0 1px 0 rgba(255, 255, 255, 0.2);\n}\n\n.mobile-menu-btn.admin-mode {\n  border-left: 4px solid #9945ff;\n}\n\n.mobile-menu-btn.admin-mode:hover {\n  box-shadow: \n    0 15px 50px var(--glass-shadow),\n    0 0 35px rgba(153, 69, 255, 0.5),\n    inset 0 1px 0 rgba(255, 255, 255, 0.2);\n}\n\n.mobile-menu-btn.student-mode {\n  border-left: 4px solid #4e44ce;\n}\n\n.mobile-menu-btn.student-mode:hover {\n  box-shadow: \n    0 15px 50px var(--glass-shadow),\n    0 0 35px rgba(78, 68, 206, 0.5),\n    inset 0 1px 0 rgba(255, 255, 255, 0.2);\n}\n\n.mobile-menu-icon {\n  font-size: 26px;\n  min-width: 26px;\n  background: var(--solana-gradient);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  filter: drop-shadow(0 0 10px var(--neon-green-glow));\n}\n\n.mobile-menu-label {\n  font-size: 17px;\n  font-weight: 600;\n  flex: 1;\n  text-align: left;\n  background: linear-gradient(135deg, #ffffff 0%, rgba(255, 255, 255, 0.85) 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* Animations */\n@keyframes orbShimmer {\n  0%, 100% { transform: translateX(-100%) translateY(-100%) rotate(0deg); }\n  50% { transform: translateX(100%) translateY(100%) rotate(180deg); }\n}\n\n@keyframes menuItemSlideIn {\n  0% {\n    opacity: 0;\n    transform: translateY(30px) scale(0.8);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes radialOpen {\n  0% {\n    opacity: 0;\n    transform: scale(0) rotate(-180deg);\n    filter: blur(10px);\n  }\n  50% {\n    opacity: 0.7;\n    filter: blur(2px);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1) rotate(0deg);\n    filter: blur(0);\n  }\n}\n\n/* Radial opening animation for menu items */\n.mobile-menu-list.opening .mobile-menu-btn {\n  animation: radialOpen 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;\n}\n\n.mobile-menu-list.opening .mobile-menu-btn:nth-child(1) { animation-delay: 0.1s; }\n.mobile-menu-list.opening .mobile-menu-btn:nth-child(2) { animation-delay: 0.2s; }\n.mobile-menu-list.opening .mobile-menu-btn:nth-child(3) { animation-delay: 0.3s; }\n.mobile-menu-list.opening .mobile-menu-btn:nth-child(4) { animation-delay: 0.4s; }\n\n/* Responsive adjustments */\n@media (max-width: 600px) {\n  .mobile-menu-orb {\n    width: 72px;\n    height: 72px;\n    right: 12px;\n    bottom: 12px;\n  }\n\n  .mobile-menu-list {\n    right: 8px;\n    bottom: 96px;\n    width: calc(100% - 24px);\n    max-width: 360px;\n    padding: 8px;\n    gap: 8px;\n  }\n\n  .mobile-menu-btn {\n    padding: 12px 14px;\n    font-size: 14px;\n  }\n\n  .mobile-menu-logo { font-size: 34px; }\n}\n\n/* Ensure menu buttons are reachable when many items exist: compact grid for very narrow screens */\n@media (max-width: 360px) {\n  .mobile-menu-list {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 8px;\n    max-height: calc(100vh - 140px);\n  }\n  .mobile-menu-btn { padding: 10px 12px; font-size: 13px; }\n}\n\n/* ======================== WALLET STATUS ICON ======================== */\n\n.wallet-status-icon {\n  position: fixed;\n  bottom: 30px;\n  right: 30px;\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  background: var(--glass-bg);\n  backdrop-filter: blur(20px);\n  border: 2px solid var(--glass-border);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n  z-index: 1000;\n  position: relative;\n  overflow: hidden;\n}\n\n.wallet-status-icon::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border-radius: 50%;\n  background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.1), transparent);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.wallet-status-icon:hover::before {\n  opacity: 1;\n}\n\n.wallet-status-icon:hover {\n  transform: scale(1.1);\n  box-shadow: \n    0 8px 32px rgba(0, 0, 0, 0.3),\n    0 0 20px rgba(255, 255, 255, 0.1);\n}\n\n.wallet-icon-inner {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n  z-index: 2;\n}\n\n.wallet-emoji {\n  filter: drop-shadow(0 0 8px rgba(255, 255, 255, 0.3));\n}\n\n.wallet-spinner {\n  animation: spin 1s linear infinite;\n  font-size: 20px;\n  color: var(--neon-glow);\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n.wallet-status-dot {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  transition: all 0.3s ease;\n}\n\n.wallet-status-icon.connected .wallet-status-dot {\n  background: #14f195;\n  box-shadow: \n    0 0 10px #14f195,\n    inset 0 0 5px rgba(255, 255, 255, 0.3);\n  animation: pulse-green 2s ease-in-out infinite;\n}\n\n.wallet-status-icon.disconnected .wallet-status-dot {\n  background: #ff9500;\n  box-shadow: \n    0 0 10px #ff9500,\n    inset 0 0 5px rgba(255, 255, 255, 0.3);\n  animation: pulse-orange 2s ease-in-out infinite;\n}\n\n.wallet-status-icon.connecting .wallet-status-dot {\n  background: #9945ff;\n  box-shadow: \n    0 0 10px #9945ff,\n    inset 0 0 5px rgba(255, 255, 255, 0.3);\n  animation: pulse-purple 1s ease-in-out infinite;\n}\n\n@keyframes pulse-green {\n  0%, 100% { \n    box-shadow: \n      0 0 10px #14f195,\n      inset 0 0 5px rgba(255, 255, 255, 0.3);\n  }\n  50% { \n    box-shadow: \n      0 0 20px #14f195,\n      0 0 30px rgba(20, 241, 149, 0.3),\n      inset 0 0 8px rgba(255, 255, 255, 0.5);\n  }\n}\n\n@keyframes pulse-orange {\n  0%, 100% { \n    box-shadow: \n      0 0 10px #ff9500,\n      inset 0 0 5px rgba(255, 255, 255, 0.3);\n  }\n  50% { \n    box-shadow: \n      0 0 20px #ff9500,\n      0 0 30px rgba(255, 149, 0, 0.3),\n      inset 0 0 8px rgba(255, 255, 255, 0.5);\n  }\n}\n\n@keyframes pulse-purple {\n  0%, 100% { \n    box-shadow: \n      0 0 10px #9945ff,\n      inset 0 0 5px rgba(255, 255, 255, 0.3);\n  }\n  50% { \n    box-shadow: \n      0 0 20px #9945ff,\n      0 0 30px rgba(153, 69, 255, 0.3),\n      inset 0 0 8px rgba(255, 255, 255, 0.5);\n  }\n}\n\n/* ======================== WALLET MODAL ======================== */\n\n.wallet-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  backdrop-filter: blur(10px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n  animation: fadeIn 0.3s ease-out;\n}\n\n.wallet-modal {\n  background: var(--glass-bg);\n  backdrop-filter: blur(30px);\n  border: 1px solid var(--glass-border);\n  border-radius: 20px;\n  width: 90%;\n  max-width: 400px;\n  box-shadow: \n    0 20px 60px rgba(0, 0, 0, 0.4),\n    inset 0 1px 0 rgba(255, 255, 255, 0.1);\n  animation: slideInUp 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n  overflow: hidden;\n}\n\n.wallet-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 28px 16px 28px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.wallet-modal-header h3 {\n  margin: 0;\n  color: #fff;\n  font-size: 20px;\n  font-weight: 600;\n  background: var(--solana-gradient);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.wallet-modal-close {\n  background: none;\n  border: none;\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 24px;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n}\n\n.wallet-modal-close:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: rgba(255, 255, 255, 0.9);\n  transform: scale(1.1);\n}\n\n.wallet-modal-content {\n  padding: 24px 28px 28px 28px;\n}\n\n.wallet-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n  font-size: 18px;\n  font-weight: 600;\n  color: #fff;\n}\n\n.wallet-status-indicator {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  animation: pulse 2s ease-in-out infinite;\n}\n\n.wallet-status-indicator.connected {\n  background: #14f195;\n  box-shadow: 0 0 10px #14f195;\n}\n\n.wallet-status-indicator.disconnected {\n  background: #ff9500;\n  box-shadow: 0 0 10px #ff9500;\n}\n\n.wallet-address {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  padding: 16px;\n  margin-bottom: 24px;\n  font-family: 'Monaco', 'Menlo', monospace;\n  font-size: 16px;\n  color: var(--neon-glow);\n  text-align: center;\n  word-break: break-all;\n}\n\n.wallet-actions {\n  display: flex;\n  gap: 12px;\n  flex-direction: column;\n}\n\n.wallet-btn {\n  padding: 14px 24px;\n  border: none;\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n  position: relative;\n  overflow: hidden;\n}\n\n.wallet-btn.primary {\n  background: var(--solana-gradient);\n  color: #fff;\n  box-shadow: 0 4px 20px rgba(153, 69, 255, 0.3);\n}\n\n.wallet-btn.primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 30px rgba(153, 69, 255, 0.4);\n}\n\n.wallet-btn.secondary {\n  background: rgba(255, 255, 255, 0.1);\n  color: #fff;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.wallet-btn.secondary:hover {\n  background: rgba(255, 255, 255, 0.15);\n  transform: translateY(-2px);\n}\n\n.wallet-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.wallet-btn:active {\n  transform: scale(0.98);\n}\n\n.wallet-modal p {\n  color: rgba(255, 255, 255, 0.8);\n  line-height: 1.5;\n  margin-bottom: 24px;\n  text-align: center;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(50px) scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n/* ======================== HORIZONTAL MENU FOR MOBILE ADMIN ======================== */\n\n.horizontal-menu-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.8);\n  backdrop-filter: blur(10px);\n  z-index: 2000;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding-top: 0;\n  animation: fadeIn 0.3s ease-out;\n}\n\n.horizontal-menu-container {\n  background: var(--glass-bg);\n  backdrop-filter: blur(30px);\n  border: 1px solid var(--glass-border);\n  border-radius: 0 0 25px 25px;\n  width: 100%;\n  max-width: 100vw;\n  box-shadow: \n    0 20px 60px rgba(0, 0, 0, 0.4),\n    0 0 40px var(--neon-green-glow),\n    inset 0 1px 0 rgba(255, 255, 255, 0.1);\n  animation: slideDownIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);\n  overflow: hidden;\n}\n\n.horizontal-menu-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 25px 15px 25px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  background: linear-gradient(135deg, \n    rgba(20, 241, 149, 0.1) 0%, \n    rgba(153, 69, 255, 0.05) 50%,\n    rgba(255, 215, 0, 0.1) 100%);\n}\n\n.logo-section {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.logo-icon {\n  font-size: 32px;\n  background: var(--solana-gradient);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  filter: drop-shadow(0 0 15px var(--neon-green-glow));\n}\n\n.logo-text h1 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 900;\n  background: linear-gradient(135deg, #ffffff 0%, var(--neon-green) 50%, var(--admin-gold) 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  text-shadow: 0 0 20px var(--neon-green-glow);\n  line-height: 1;\n}\n\n.logo-text span {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.7);\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  margin-top: 2px;\n  display: block;\n}\n\n.close-horizontal-menu {\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 20px;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n}\n\n.close-horizontal-menu:hover {\n  background: rgba(255, 255, 255, 0.2);\n  border-color: var(--neon-green);\n  color: var(--neon-green);\n  transform: scale(1.1);\n}\n\n.horizontal-tab-menu {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1px;\n  background: rgba(255, 255, 255, 0.05);\n  margin: 0;\n}\n\n.horizontal-tab {\n  background: var(--glass-bg);\n  backdrop-filter: blur(25px);\n  border: none;\n  color: #fff;\n  padding: 20px 15px;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  position: relative;\n  overflow: hidden;\n  border-bottom: 2px solid transparent;\n}\n\n.horizontal-tab::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(20, 241, 149, 0.1), transparent);\n  transition: left 0.5s ease;\n}\n\n.horizontal-tab:hover::before {\n  left: 100%;\n}\n\n.horizontal-tab:hover {\n  background: rgba(20, 241, 149, 0.08);\n  border-bottom-color: var(--neon-green);\n  transform: translateY(-2px);\n}\n\n.horizontal-tab.active {\n  background: rgba(20, 241, 149, 0.15);\n  border-bottom-color: var(--neon-green);\n  box-shadow: \n    0 0 20px rgba(20, 241, 149, 0.3),\n    inset 0 1px 0 rgba(255, 255, 255, 0.2);\n}\n\n.horizontal-tab.admin-mode.active {\n  border-bottom-color: var(--admin-gold);\n  background: rgba(255, 215, 0, 0.15);\n  box-shadow: \n    0 0 20px rgba(255, 215, 0, 0.3),\n    inset 0 1px 0 rgba(255, 255, 255, 0.2);\n}\n\n.tab-icon {\n  font-size: 24px;\n  min-width: 24px;\n  background: var(--solana-gradient);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  filter: drop-shadow(0 0 10px var(--neon-green-glow));\n}\n\n.tab-content {\n  flex: 1;\n  text-align: left;\n}\n\n.tab-label {\n  font-size: 16px;\n  font-weight: 600;\n  display: block;\n  margin-bottom: 4px;\n  background: linear-gradient(135deg, #ffffff 0%, rgba(255, 255, 255, 0.9) 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.tab-description {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.6);\n  font-weight: 400;\n}\n\n.admin-crown-tab {\n  font-size: 18px;\n  animation: crownFloat 2s ease-in-out infinite;\n  filter: drop-shadow(0 0 8px rgba(255, 215, 0, 0.8));\n}\n\n.horizontal-wallet-status {\n  padding: 20px 25px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  background: linear-gradient(135deg, \n    rgba(20, 241, 149, 0.05) 0%, \n    transparent 50%,\n    rgba(255, 215, 0, 0.05) 100%);\n}\n\n.wallet-info-horizontal {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.wallet-details {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.wallet-details .wallet-status {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--neon-green);\n  margin-bottom: 2px;\n}\n\n.wallet-address-horizontal {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.7);\n  font-family: 'Monaco', 'Menlo', monospace;\n}\n\n.admin-badge-horizontal {\n  font-size: 10px;\n  background: var(--admin-gold);\n  color: #000;\n  padding: 4px 8px;\n  border-radius: 10px;\n  font-weight: 700;\n}\n\n/* Hide orb when horizontal menu is shown */\n.mobile-menu-orb.menu-hidden {\n  opacity: 0;\n  pointer-events: none;\n  transform: translate(-50%, 50%) scale(0.8);\n}\n\n/* Animations for horizontal menu */\n@keyframes slideDownIn {\n  0% {\n    opacity: 0;\n    transform: translateY(-100%);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Mobile wallet adjustments */\n@media (max-width: 480px) {\n  .wallet-status-icon {\n    width: 50px;\n    height: 50px;\n    bottom: 20px;\n    right: 20px;\n  }\n  \n  .wallet-icon-inner {\n    font-size: 20px;\n  }\n  \n  .wallet-status-dot {\n    width: 10px;\n    height: 10px;\n    top: 6px;\n    right: 6px;\n  }\n  \n  .wallet-modal {\n    margin: 20px;\n    width: calc(100% - 40px);\n  }\n  \n  .wallet-modal-header {\n    padding: 20px 24px 12px 24px;\n  }\n  \n  .wallet-modal-content {\n    padding: 20px 24px 24px 24px;\n  }\n\n  .wallet-connector-container {\n    bottom: 40px;\n  }\n\n  .wallet-connector {\n    min-width: 180px;\n    padding: 14px 20px;\n  }\n\n  .admin-welcome .welcome-content {\n    padding: 25px 35px;\n    margin: 0 20px;\n  }\n\n  /* Mobile horizontal menu adjustments */\n  .horizontal-menu-header {\n    padding: 15px 20px 12px 20px;\n  }\n\n  .logo-text h1 {\n    font-size: 20px;\n  }\n\n  .horizontal-tab {\n    padding: 18px 12px;\n    gap: 10px;\n  }\n\n  .tab-icon {\n    font-size: 20px;\n  }\n\n  .tab-label {\n    font-size: 14px;\n  }\n\n  .tab-description {\n    font-size: 11px;\n  }\n\n  .horizontal-wallet-status {\n    padding: 15px 20px;\n  }\n}\n\n/* Admin Welcome Message */\n.admin-welcome {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 3000;\n  animation: welcomeSlideIn 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.welcome-content {\n  background: var(--glass-bg);\n  backdrop-filter: blur(30px);\n  border: 2px solid var(--admin-gold);\n  border-radius: 20px;\n  padding: 30px 40px;\n  text-align: center;\n  box-shadow: \n    0 20px 60px rgba(0, 0, 0, 0.4),\n    0 0 40px rgba(255, 215, 0, 0.3),\n    inset 0 1px 0 rgba(255, 255, 255, 0.2);\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.welcome-icon {\n  font-size: 40px;\n  animation: crownFloat 2s ease-in-out infinite;\n  filter: drop-shadow(0 0 15px rgba(255, 215, 0, 0.8));\n}\n\n.welcome-text h3 {\n  margin: 0 0 8px 0;\n  font-size: 24px;\n  font-weight: 700;\n  background: linear-gradient(135deg, var(--admin-gold) 0%, #fff 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.welcome-text p {\n  margin: 0;\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 16px;\n}\n\n/* Wallet Connector - Lower Middle Section */\n.wallet-connector-container {\n  position: fixed;\n  bottom: 60px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 1000;\n}\n\n.wallet-connector {\n  background: var(--glass-bg);\n  backdrop-filter: blur(25px);\n  border: 2px solid var(--glass-border);\n  border-radius: 25px;\n  padding: 16px 24px;\n  cursor: pointer;\n  transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);\n  position: relative;\n  overflow: hidden;\n  min-width: 200px;\n  box-shadow: \n    0 10px 40px rgba(0, 0, 0, 0.3),\n    0 0 20px rgba(20, 241, 149, 0.1),\n    inset 0 1px 0 rgba(255, 255, 255, 0.1);\n}\n\n.wallet-connector-glow {\n  position: absolute;\n  top: -2px;\n  left: -2px;\n  right: -2px;\n  bottom: -2px;\n  border-radius: 25px;\n  background: conic-gradient(from 0deg, var(--neon-green), transparent, var(--purple-glow), transparent, var(--neon-green));\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  z-index: -1;\n}\n\n.wallet-connector:hover .wallet-connector-glow {\n  opacity: 0.3;\n  animation: rotateGlow 2s linear infinite;\n}\n\n.wallet-connector:hover {\n  transform: translateY(-3px) scale(1.02);\n  border-color: var(--neon-green);\n  box-shadow: \n    0 15px 50px rgba(0, 0, 0, 0.4),\n    0 0 30px var(--neon-green-glow),\n    inset 0 1px 0 rgba(255, 255, 255, 0.2);\n}\n\n.wallet-connector.admin-wallet {\n  border-color: var(--admin-gold);\n}\n\n.wallet-connector.admin-wallet:hover {\n  border-color: var(--admin-gold);\n  box-shadow: \n    0 15px 50px rgba(0, 0, 0, 0.4),\n    0 0 30px rgba(255, 215, 0, 0.4),\n    inset 0 1px 0 rgba(255, 255, 255, 0.2);\n}\n\n.wallet-connector-content {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  position: relative;\n  z-index: 2;\n}\n\n.wallet-info-compact {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n}\n\n.wallet-status {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--neon-green);\n}\n\n.wallet-address-short {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.7);\n  font-family: 'Monaco', 'Menlo', monospace;\n}\n\n.admin-badge {\n  font-size: 10px;\n  background: var(--admin-gold);\n  color: #000;\n  padding: 2px 6px;\n  border-radius: 8px;\n  font-weight: 700;\n  margin-top: 2px;\n}\n\n.wallet-text {\n  font-size: 14px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.wallet-emoji {\n  font-size: 20px;\n  filter: drop-shadow(0 0 8px rgba(255, 255, 255, 0.3));\n}\n\n.wallet-status-dot {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  transition: all 0.3s ease;\n}\n\n.wallet-status-dot.connected {\n  background: var(--neon-green);\n  box-shadow: 0 0 10px var(--neon-green);\n  animation: pulse-green 2s ease-in-out infinite;\n}\n\n.wallet-status-dot.disconnected {\n  background: #ff9500;\n  box-shadow: 0 0 10px #ff9500;\n  animation: pulse-orange 2s ease-in-out infinite;\n}\n\n.wallet-status-dot.admin {\n  background: var(--admin-gold);\n  box-shadow: 0 0 10px var(--admin-gold);\n  animation: pulse-gold 2s ease-in-out infinite;\n}\n\n/* Enhanced Animations */\n@keyframes welcomeSlideIn {\n  0% {\n    opacity: 0;\n    transform: translate(-50%, -50%) scale(0.7) rotate(-10deg);\n  }\n  100% {\n    opacity: 1;\n    transform: translate(-50%, -50%) scale(1) rotate(0deg);\n  }\n}\n\n@keyframes crownFloat {\n  0%, 100% {\n    transform: translateY(0px) rotate(0deg);\n  }\n  50% {\n    transform: translateY(-8px) rotate(5deg);\n  }\n}\n\n@keyframes rotateGlow {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n@keyframes diskFloat {\n  0%, 100% {\n    transform: translate(-50%, 50%) translateY(0px) rotate(0deg);\n  }\n  33% {\n    transform: translate(-50%, 50%) translateY(-5px) rotate(1deg);\n  }\n  66% {\n    transform: translate(-50%, 50%) translateY(3px) rotate(-1deg);\n  }\n}\n\n@keyframes diskPulse {\n  0%, 100% {\n    box-shadow: \n      0 20px 50px rgba(0, 0, 0, 0.3),\n      0 0 30px var(--neon-green-glow),\n      inset 0 1px 0 rgba(255, 255, 255, 0.1);\n  }\n  50% {\n    box-shadow: \n      0 25px 60px rgba(0, 0, 0, 0.4),\n      0 0 50px var(--neon-green-glow),\n      0 0 80px rgba(20, 241, 149, 0.4),\n      inset 0 1px 0 rgba(255, 255, 255, 0.15);\n  }\n}\n\n@keyframes pulse-green {\n  0%, 100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.7;\n    transform: scale(1.1);\n  }\n}\n\n@keyframes pulse-orange {\n  0%, 100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.7;\n    transform: scale(1.1);\n  }\n}\n\n@keyframes pulse-gold {\n  0%, 100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.7;\n    transform: scale(1.1);\n  }\n}\n\n/* Connect Popup */\n.connect-popup {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 3000;\n  animation: welcomeSlideIn 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.connect-popup-content {\n  background: var(--glass-bg);\n  backdrop-filter: blur(30px);\n  border: 2px solid var(--neon-green);\n  border-radius: 20px;\n  padding: 30px 35px;\n  text-align: center;\n  box-shadow: \n    0 20px 60px rgba(0, 0, 0, 0.4),\n    0 0 40px var(--neon-green-glow),\n    inset 0 1px 0 rgba(255, 255, 255, 0.2);\n  max-width: 320px;\n  margin: 0 20px;\n}\n\n.connect-popup-content h4 {\n  margin: 0 0 12px 0;\n  font-size: 22px;\n  font-weight: 700;\n  background: linear-gradient(135deg, var(--neon-green) 0%, #fff 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.connect-popup-content p {\n  margin: 0 0 16px 0;\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 15px;\n  line-height: 1.4;\n}\n\n/* Small shimmer skeleton for StatsGrid initial load */\n.stat-shimmer {\n  height: 44px;\n  border-radius: 8px;\n  background: linear-gradient(90deg, rgba(255,255,255,0.03) 25%, rgba(255,255,255,0.06) 50%, rgba(255,255,255,0.03) 75%);\n  background-size: 200% 100%;\n  animation: shimmer 1.2s linear infinite;\n}\n\n@keyframes shimmer {\n  0% { background-position: -200% 0; }\n  100% { background-position: 200% 0; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
